<div class="row">
  <div class="col-12 col-md-6">
    @if (calcService.chartData().monthlyBaseSalary > 0 && !loading) {
    <div class="h-100">
      <tvoed-rechner-monthly-chart [data]="calcService.chartData()"></tvoed-rechner-monthly-chart>
    </div>
    } @if (calcService.chartData().monthlyBaseSalary <= 0) {
    <div>
      <h2 class="welcome">Der Gehaltsrechner für den TVöD (Tarifvertrag öffentlicher Dienst)</h2>
      <div class="info-paragraph mb-3">
        <div class="icon me-3"><i class="fa-solid fa-info fa-3x"></i></div>
        <p>
          Wenn du wissen möchtest, wie sich dein monatliches und jährliches Entgelt im <b>TVöD (Tarifvertrag für den öffentlichen Dienst)</b> zusammensetzt, bist du hier genau
          richtig. Im Gehaltsrechner wird aufgeschlüsselt, wie hoch deine monatlichen Gehaltszahlungen sind und wann Zusatzentgelte (Jahressonderzahlung, Leistungsentgelt) gezahlt
          werden. Du hast Anregungen, wie man den Rechner verbessern kann? Schreibe mir an <a href="mailto:hi@tvoedgehalt.de">hi&#64;tvoedgehalt.de</a>!
        </p>
      </div>
      <div class="info-paragraph mb-3">
        <div class="icon me-3"><i class="fa-solid fa-bug fa-3x"></i></div>
        <p>
          Falls dir ein Fehler auffällt, zögere nicht mir eine kurze E-Mail (<a href="mailto:bug@tvoedgehalt.de">bug&#64;tvoedgehalt.de</a>) zu schreiben, sodass ich das
          schnellstmöglich anpassen kann! Falls es um falsche Daten geht, schick mir gerne auch direkt die Quelle mit, wo du die korrekten Daten gefunden hast.
        </p>
      </div>
      <div class="info-paragraph mb-3">
        <div class="icon me-3">
          <i class="fa-solid fa-triangle-exclamation fa-3x"></i>
        </div>
        <p>
          <b>Disclaimer:</b> Trotz intensiver Recherche können in der Berechnung Fehler sein. Das Gehalt kann individuell abweichen, z.B. durch persönliche Zulagen,
          Stufenlaufzeiten oder regionale Besonderheiten. Nutze diesen Rechner als Orientierung.
        </p>
      </div>
    </div>
    }
  </div>

  <div class="col-12 col-md-6">
    <form [formGroup]="form">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Tarifabschluss</mat-label>
        <mat-select formControlName="labourAgreementId" placeholder="Tarifvertrag" [compareWith]="calcService.compareWith">
          @for (labourAgreement of labourAgreements(); track labourAgreement) {
          <mat-option [value]="labourAgreement.id">
            {{ labourAgreement.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Bereich</mat-label>
        <mat-select formControlName="subTable" placeholder="Bereich">
          @for (subTable of calcService.subTables(); track subTable) {
          <mat-option [value]="subTable.key">
            {{ subTable.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Entgeltgruppe</mat-label>
        <mat-select formControlName="payGrade" placeholder="Entgeltgruppe">
          @for (payGrade of calcService.payGrades(); track payGrade) {
          <mat-option [value]="payGrade">
            {{ payGrade }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Stufe</mat-label>
        <mat-select formControlName="payGradeStep" placeholder="Stufe">
          @for (payGradeStep of calcService.payGradeSteps(); track payGradeStep) {
          <mat-option [value]="payGradeStep">
            {{ payGradeStep }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="row mb-3">
        <div class="col-12 col-xl-6 d-flex align-items-baseline">
          <mat-form-field appearance="outline" class="w-100 mb-2">
            <mat-label>wöchentliche Arbeitszeit</mat-label>
            <input formControlName="weeklyWorkingHours" type="number" matInput placeholder="wöchentliche Arbeitszeit" />

            <mat-icon matSuffix><i class="fa-solid fa-clock me-3"></i></mat-icon>

            @if (form.get('weeklyWorkingHours')?.errors) {
            <mat-hint class="error">Zahl zwischen 30 und 45</mat-hint>
            } @if (!form.get('weeklyWorkingHours')?.errors) {
            <mat-hint
              class="info"
              matTooltip="Die tarifliche Wochenarbeitszeit wird automatisch basierend auf deinem gewählten Bereich gesetzt (z.B. 39h für TVöD VKA/Bund). Sie wird benötigt, um Überstunden richtig zu berechnen."
              #tooltipWeeklyWorkingHoursExplaination="matTooltip"
              (click)="tooltipWeeklyWorkingHoursExplaination.show()"
            >
              Warum ändert sich das Gehalt nicht?
            </mat-hint>
            }
          </mat-form-field>
          <div class="ms-3">
            <i
              class="fa-solid fa-circle-info"
              matTooltip="Die wöchentliche Arbeitszeit wird automatisch je nach Bereich gesetzt. Bei TVöD VKA und Bund sind es im Regelfall 39 Stunden pro Woche. Dieser Wert wirkt sich nur auf das Gehalt aus, wenn du auch zusätzliche Wochenarbeitszeit angibst."
              #tooltipWeeklyWorkingHours="matTooltip"
              (click)="tooltipWeeklyWorkingHours.show()"
            ></i>
          </div>
        </div>

        <div class="col-12 col-xl-6 d-flex align-items-baseline">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>wöchentliche zusätzliche Arbeitszeit</mat-label>
            <input formControlName="weeklyAdditionalWorkingHours" type="number" matInput placeholder="wöchentliche zusätzliche Arbeitszeit" />

            <mat-icon matSuffix><i class="fa-solid fa-clock me-3"></i></mat-icon>

            @if (form.get('weeklyAdditionalWorkingHours')?.errors) {
            <mat-hint class="error">Zahl zwischen -20 und 20</mat-hint>
            }
          </mat-form-field>
          <div class="ms-3">
            <i
              class="fa-solid fa-circle-info"
              matTooltip="Gib hier zusätzliche Stunden oder reduzierte Stunden an. Dies können z.B. Überstunden, Erhöhung oder Verringerung der Arbeitszeit, oder ähnliches sein. Falls du deine Stunden reduziert hast, kannst du einen negativen Wert angeben."
              #tooltipAdditionalWorkingHours="matTooltip"
              (click)="tooltipAdditionalWorkingHours.show()"
            ></i>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xl-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Sonderzahlung</mat-label>
            <input formControlName="additionalExtraPayment" type="number" matInput placeholder="Sonderzahlung" />

            <mat-icon matSuffix><i class="fa-solid fa-euro-sign me-3"></i></mat-icon>
          </mat-form-field>
        </div>

        <div class="col-12 col-xl-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Leistungsentgelt (Jahresbetrag)</mat-label>
            <input formControlName="leistungsentgeltAmount" type="number" matInput placeholder="Leistungsentgelt in EUR (jährlich)" />
            <mat-icon matSuffix><i class="fa-solid fa-euro-sign me-3"></i></mat-icon>
            <mat-hint
              class="info"
              matTooltip="Leistungsentgelt (LOB) gem. § 18 TVöD: Leistungsorientierte Bezahlung als jährliche Einmalzahlung. Das tarifliche Gesamtvolumen beträgt 2% der ständigen Monatsentgelte des Vorjahres aller Beschäftigten. Die individuelle Höhe wird durch systematische Leistungsbewertung und/oder Zielvereinbarung bestimmt (Dienst-/Betriebsvereinbarung). Der statistische Durchschnitt liegt bei 2% — je nach individueller Bewertung sind 0% bis 8% möglich."
              #tooltipLOB="matTooltip"
              (click)="tooltipLOB.show()"
            >
              Jahresbetrag gem. § 18 TVöD (LOB)
            </mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="mb-3">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Zulagen </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="row">
              <div class="col-12">
                <mat-checkbox formControlName="zulagenSchicht" class="w-100">
                  Wechselschichtzulage (105€/110€ pro Monat)
                  <i
                    class="fa-solid fa-circle-info ms-1"
                    matTooltip="Ständige Wechselschichtzulage gem. § 8 Abs. 5 TVöD: 105€/Monat (VKA) bzw. 110€/Monat (Bund)."
                    #tooltipSchicht="matTooltip"
                    (click)="tooltipSchicht.show(); $event.preventDefault()"
                  ></i>
                </mat-checkbox>
              </div>
              <div class="col-12">
                <mat-checkbox formControlName="zulagenNacht" class="w-100">
                  Nachtzuschlag (20%/Std., ~40 Std./Monat)
                  <i
                    class="fa-solid fa-circle-info ms-1"
                    matTooltip="20% des Stundenentgelts pro Nachtstunde (§ 8 Abs. 1 TVöD). Geschätzt auf Basis von ca. 40 Nachtstunden pro Monat. Der genaue Betrag hängt von den tatsächlich geleisteten Nachtstunden ab."
                    #tooltipNacht="matTooltip"
                    (click)="tooltipNacht.show(); $event.preventDefault()"
                  ></i>
                </mat-checkbox>
              </div>
              <div class="col-12">
                <mat-checkbox formControlName="zulagenWochenende" class="w-100">
                  Wochenend-/Feiertagszuschlag (25%/Std., ~20 Std./Monat)
                  <i
                    class="fa-solid fa-circle-info ms-1"
                    matTooltip="Sonntagsarbeit: 25%, Samstag 13-21 Uhr: 20%, Feiertag: 35-135% des Stundenentgelts (§ 8 Abs. 1 TVöD). Geschätzt mit 25% × ca. 20 Wochenendstunden/Monat."
                    #tooltipWochenende="matTooltip"
                    (click)="tooltipWochenende.show(); $event.preventDefault()"
                  ></i>
                </mat-checkbox>
              </div>
              <div class="col-12">
                <mat-checkbox formControlName="zulagenUeberstunden" class="w-100">
                  Überstundenzuschlag (30%/Std.)
                  <i
                    class="fa-solid fa-circle-info ms-1"
                    matTooltip="30% des Stundenentgelts pro Überstunde (§ 8 Abs. 1 TVöD, E 1-E 9b). Ab E 10 i.d.R. kein Überstundenzuschlag. Wird auf Basis der eingegebenen zusätzlichen Wochenstunden berechnet."
                    #tooltipUeberstunden="matTooltip"
                    (click)="tooltipUeberstunden.show(); $event.preventDefault()"
                  ></i>
                </mat-checkbox>
              </div>
              <div class="col-12">
                <mat-checkbox formControlName="zulagenFunktion" class="w-100">
                  Funktionszulage (~100€/Monat)
                  <i
                    class="fa-solid fa-circle-info ms-1"
                    matTooltip="Pauschale Funktionszulage z.B. für Vorarbeiter oder besondere Verantwortung. Der tatsächliche Betrag kann abweichen."
                    #tooltipFunktion="matTooltip"
                    (click)="tooltipFunktion.show(); $event.preventDefault()"
                  ></i>
                </mat-checkbox>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-checkbox formControlName="rememberInputs" class="w-100"> Eingaben merken </mat-checkbox>
        </div>
      </div>
    </form>

    @if (this.selectedLabourAgreement()?.info) {
    <div class="alert alert-info" role="alert">
      {{ this.selectedLabourAgreement()?.info }}
    </div>
    } @if (calcService.chartData().monthlyBaseSalary > 0 && !loading) {
    <table class="table table-sm">
      <thead>
        <tr>
          <th></th>
          <th scope="col" class="text-end">Gehalt</th>
        </tr>
      </thead>
      @if (calcService.extraHoursSalary() !== 0 || calcService.zulagenDetails().length > 0) {
      <tbody class="table-group-divider">
        <tr>
          <th scope="row">Tarifliches Grundgehalt</th>
          <td class="text-end">{{ calcService.baseSalary() | currency : 'EUR' }}</td>
        </tr>
      </tbody>
      } @if (calcService.extraHoursSalary() > 0) {
      <tbody class="table-group-divider">
        <tr>
          <th scope="row">Mehrstunden</th>
          <td class="text-end">{{ calcService.extraHoursSalary() | currency : 'EUR' }}</td>
        </tr>
      </tbody>
      } @if (calcService.extraHoursSalary() < 0) {
      <tbody class="table-group-divider">
        <tr>
          <th scope="row">Minderstundenabzug</th>
          <td class="text-end">{{ calcService.extraHoursSalary() | currency : 'EUR' }}</td>
        </tr>
      </tbody>
      } @if (calcService.zulagenDetails().length > 0) {
      <tbody class="table-group-divider">
        @for (zulage of calcService.zulagenDetails(); track zulage.name) {
        <tr>
          <th scope="row">
            {{ zulage.name }}
            <i class="fa-solid fa-circle-info" [matTooltip]="zulage.info" #tooltipZulage="matTooltip" (click)="tooltipZulage.show()"></i>
          </th>
          <td class="text-end">{{ zulage.amount | currency : 'EUR' }}</td>
        </tr>
        }
      </tbody>
      }
      <tbody class="table-group-divider">
        <tr>
          <th scope="row">Monatliches Gehalt</th>
          <td class="text-end">{{ calcService.monthlySalary() + calcService.zulagenTotal() | currency : 'EUR' }}</td>
        </tr>
      </tbody>
      <tbody class="table-group-divider">
        @for (extraPayment of calcService.extraPayments(); track extraPayment) {
        <tr>
          <th scope="row">
            {{ extraPayment.name }} ({{ extraPayment.paymentMonth }})
            <i class="fa-solid fa-circle-info" [matTooltip]="extraPayment.info" #tooltip="matTooltip" (click)="tooltip.show()"></i>
          </th>
          <td class="text-end">{{ extraPayment.money | currency : 'EUR' }}</td>
        </tr>
        } @if (calcService.state().additionalExtraPayment) {
        <tr>
          <th scope="row">Sonderzahlung</th>
          <td class="text-end">{{ calcService.state().additionalExtraPayment | currency : 'EUR' }}</td>
        </tr>
        }
      </tbody>
      <tfoot class="table-group-divider">
        <tr>
          <th scope="row">
            Durchschnittlicher Brutto Stundenlohn
            <i
              class="fa-solid fa-circle-info"
              matTooltip="Berechnet auf das Brutto Jahresgehalt in Abhängigkeit zu den angegebenen Wochenstunden."
              #tooltip="matTooltip"
              (click)="tooltip.show()"
            ></i>
          </th>
          <td class="text-end">{{ calcService.totalHourlySalary() | currency : 'EUR' }}</td>
        </tr>
        <tr>
          <th scope="row">Durchschnittliches Brutto Monatsgehalt</th>
          <td class="text-end">{{ calcService.totalMonthlySalary() | currency : 'EUR' }}</td>
        </tr>
        <tr>
          <th scope="row">Brutto Jahresgehalt</th>
          <td class="text-end">{{ calcService.totalAnnualSalary() | currency : 'EUR' }}</td>
        </tr>
        @if (hasBruttoNettoSettings() && bruttoNettoReady() && estimatedNettoMonthly() > 0) {
        <tr>
          <th scope="row">
            Geschätztes Netto Monatsgehalt
            <i
              class="fa-solid fa-circle-info"
              matTooltip="Schätzung basierend auf deinen gespeicherten Eingaben im Brutto-Netto-Rechner."
              #tooltipNettoMonthly="matTooltip"
              (click)="tooltipNettoMonthly.show()"
            ></i>
          </th>
          <td class="text-end">{{ estimatedNettoMonthly() | currency : 'EUR' }}</td>
        </tr>
        <tr>
          <th scope="row">Geschätztes Netto Jahresgehalt</th>
          <td class="text-end">{{ estimatedNettoYearly() | currency : 'EUR' }}</td>
        </tr>
        } @if (!hasBruttoNettoSettings() && calcService.totalMonthlySalary() > 0) {
        <tr>
          <th scope="row">Netto Gehalt berechnen</th>
          <td class="text-end">
            <a [routerLink]="['/brutto-netto-rechner']" [queryParams]="{ bruttoMonthly: bruttoMonthlyRounded() }">
              zum Brutto-Netto-Rechner <i class="fa-solid fa-arrow-right"></i>
            </a>
          </td>
        </tr>
        }
      </tfoot>
    </table>
    } @if (calcService.generatedUrl()) {
    <div>
      <span class="copy" [cdkCopyToClipboard]="calcService.generatedUrl()" (cdkCopyToClipboardCopied)="copied($event)">
        Link zur Auswahl in Zwischenablage kopieren
        <i class="fa-regular fa-clone"></i>
      </span>
    </div>
    }
  </div>
</div>
